import React, { Component } from "react";
import Chart from "react-apexcharts";

class PCGraph extends Component {
  constructor(props) {
    super(props);

    this.state = {
      options: {
        labels: [
          "1-30 Days",
          "31-60 Days",
          "61-90 Days",
          "91-120 Days",
          "121-150 Days",
          "151-180 Days",
        ],
        colors: [
          "#004c6d",
          "#346888",
          "#5886a5",
          "#7aa6c2",
          "#9dc6e0",
          "#c1e7ff",
        ],

        legend: {
          show: false,
        },

        tooltip: {
          enabled: true,
          fillSeriesColor: false,
          marker: {
            show: false,
          },
        },

        dataLabels: {
          enabled: true,
          textAnchor: "middle",
          distributed: true,
          style: {
            fontSize: "9px",
            fontFamily: "Helvetica, Arial, sans-serif",
            fontWeight: "bold",
          },

          dropShadow: {
            enabled: true,
            top: 2,
            left: 2,
            blur: 2,
            color: "#000",
            opacity: 0.5,
          },

          formatter: function (value, opts) {
            const name = opts.w.globals.labels[opts.seriesIndex];
            return [name, value.toFixed(3) + "%"];
          },
        },

        plotOptions: {
          pie: {
            startAngle: -30,
            endAngle: 330,
            donut: {
              size: "43%",
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: "11px",
                },
                value: {
                  show: true,
                  fontSize: "16px",
                  offsetY: -3,
                },
                total: {
                  show: true,
                  showAlways: true,
                  label: "Projects Created",
                  fontSize: "12px",
                  fontWeight: "600",
                  color: "#373d3f",
                },
              },
            },
          },
        },
      },
      series: [21, 12, 8, 5, 7, 2],
    };
  }

  render() {
    return (
      <div className="donut">
        <Chart
          options={this.state.options}
          series={[
            this.props.data.thirty,
            this.props.data.sixty,
            this.props.data.ninty,
            this.props.data.onetwenty,
            this.props.data.onefifty,
            this.props.data.oneeighty,
          ]}
          type="donut"
          height="280"
        />
      </div>
    );
  }
}

export default PCGraph;
